<template>
    <div>
        <div class="siteHeader">
            <div class="menu" @mouseover="mouseover" @mouseleave="mouseleave">
                <i class="fa-solid fa-bars fa-2xl"></i>
                <div v-if="isOpen" class="dropdownMenu">
                    <a class="routerLink" v-for="route in pages" :key="route.path" :to="route.path" :href="route.path">{{ route.meta.title }}</a>
                </div>
            </div>
            <div class="siteTitle">
                Custom Solutions Administration
            </div>
        </div>
        <div class="headerBackdrop"></div>
    </div>
</template>

<script>
export default {
    name: 'MaintenanceHeader',
    data: function() {
        return {
            pages: [],
            isOpen: false
        }
    },
    mounted() {
        let routes = this.$router.options.routes;
        for(let i = 0; i < routes.length; i++) {
            if(routes[i].meta && routes[i].meta.inMenu)
                this.pages.push(routes[i]);
        }
        this.pages.sort((a,b) => {
            if(a.meta.title < b.meta.title) return -1;
            if(b.meta.title < a.meta.title) return 1;
            return 0;
        })
    },
    methods: {
        mouseover: function () {
            this.isOpen = true;
        },
        mouseleave: function () {
            this.isOpen = false;
        }
    }
}
</script>
